var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "areadiv-parent" }, [
    _c("div", { staticClass: "chartdiv", attrs: { id: "chartdiv_area" } }),
    _vm._v(" "),
    _c("div", { staticClass: "chart-legend" }, [
      _c("span", [_vm._v(_vm._s(_vm.name))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }